<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-3">Adatvédelmi nyilatkozat</h1>
      <div class="bordered-container mt-4">
        <b-row cols="1" class="text-left">
          <b-col>
            <p>
              <strong>1. Az adatkezelő személye és az adatkezelés helye</strong>
            </p>
            <table border="0" cellpadding="0">
              <tbody>
                <tr>
                  <td width="120">
                    <p>
                      Adatkezelő:
                    </p>
                  </td>
                  <td>
                    <p>
                      MGFÜ Magyar Gazdaságfejlesztési Ügynökség (a továbbiakban: MGFÜ.)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="120">
                    <p>
                      Székhely:
                    </p>
                  </td>
                  <td>
                    <p>
                      1074 Budapest, Rákóczi út 70-72.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="120">
                    <p>
                      Adószám:
                    </p>
                  </td>
                  <td>
                    <p>
                      23833904-2-42
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="120">
                    <p>
                      Email:
                    </p>
                  </td>
                  <td>
                    <p>
                      info@mgfu.hu
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="120">
                    <p>
                      Telefon:
                    </p>
                  </td>
                  <td>
                    <p>
                      +36 1 312 2213
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p><strong>Adatvédelmi tisztviselő:</strong> dr. Nagy Katalin</p>
            <p>Címe: 1074 Budapest, Rákóczi út 70-72.</p>
            <p>E-mail: adatvedelem@mgfu.hu</p>
            <p>Telefon: +36 1 312 22 13</p>
            <p>
              <strong>A </strong>
              <strong>
                jelen Adatkezelési Tájékoztatóban hivatkozott, a honlapot (vállalkozói portált) érintő szolgáltatások
                esetében jelenleg alapesetben nem valósul meg személyes adatkezelés. Tájékoztató jelleggel viszont az
                adatkezelési alapelveket, fontosabb tudnivalókat összesíteni kívánjuk, mivel nem zárható ki, hogy nem
                felhasználói, hanem érintetti minőségben találkozik a természetes személy a vállalkozói portál
                szolgáltatásaival.
              </strong>
            </p>
            <p>
              Fontos továbbá, hogy az MGFÜ kiemelt figyelmet fordít a vele kapcsolatba kerülő személyek személyes
              adatainak védelmére, azok pontosságára és bizalmas jellegére, mindent megtesz annak érdekében, hogy a
              rendelkezésére bocsátott személyes adatokat célhoz kötötten és a korlátozott tárolhatóság jegyében csak és
              kizárólag megfelelő jogalappal kezelje, illetve, hogy az általa kezelt személyes adatokat kellő jogalap
              hiányában ne adja át harmadik személyek vagy szervezetek számára, ill. azokat a kezelés jogalapjának
              megszűnését követően törölje. Az MGFÜ a fenti célkitűzéseire tekintettel mindent megtesz annak érdekében,
              hogy a személyes adatok kezelésére vonatkozó alapelvek a személyes adatok kezelésének folyamata során
              teljes mértékben, korlátozás nélkül és minden esetben érvényesüljenek, úgymint különösen a jogszerűség,
              tisztességes eljárás és átláthatóság elve; a célhoz kötöttség elve; az adattakarékosság elve; a pontosság
              elve; a korlátozott tárolhatóság elve; az integritás és bizalmas jelleg elve és a elszámoltathatóság elve.
            </p>
            <p>
              <strong>
                2. Általános rendelkezések és az adatkezelési tájékoztatóban használt fogalmak
              </strong>
            </p>
            <p>
              A jelen Adatkezelési Tájékoztatóban használt, az alábbiakban megjelölt fogalmak a következő jelentéssel
              bírnak:
            </p>
            <p>
              <strong>Adatkezelés</strong>
              : személyes adatokon vagy adatállományokon automatizált vagy nem automatizált módon végzett bármely
              művelet vagy műveletek összessége, így a gyűjtés, rögzítés, rendszerezés, tárolás, átalakítás vagy
              megváltoztatás, lekérdezés, betekintés, felhasználás, közlés továbbítás, terjesztés vagy egyéb módon
              történő hozzáférhetővé tétel útján, összehangolás vagy összekapcsolás, korlátozás, törlés, illetve
              megsemmisítés.
            </p>
            <p>
              <strong>Adatkezelő</strong>
              : az a természetes vagy jogi személy, amely a személyes adatok kezelésének céljait és eszközeit önállóan
              vagy másokkal együtt meghatározza, jelen esetben az MGFÜ.
            </p>
            <p>
              <strong>Személyes adat:</strong>
              azonosított vagy azonosítható természetes személyre (érintett) vonatkozó bármely információ; azonosítható
              az a természetes személy, aki közvetlen vagy közvetett módon, különösen valamely azonosító, például név,
              szám, helymeghatározó adat, online azonosító vagy a természetes személy testi, fiziológiai, genetikai,
              szellemi, gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező alapján
              azonosítható.
            </p>
            <p>
              <strong>Érintett hozzájárulása:</strong>
              az érintett akaratának önkéntes, konkrét és megfelelő tájékoztatáson alapuló és egyértelmű kinyilvánítása,
              amellyel az érintett nyilatkozat vagy a megerősítést félreérthetetlenül kifejező cselekedet útján jelzi,
              hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez.
            </p>
            <p>
              <strong>Jogos érdek:</strong>
              Az adatkezelés az adatkezelő jogos érdekének érvényesítéséhez szükséges, kivéve, ha ezen érdekkel szemben
              elsőbbséget élveznek az érintett olyan érdekei vagy alapvető jogai és szabadságai, amelyek személyes
              adatok védelmét teszik szükségessé.
            </p>
            <p>
              <strong>Adatfeldolgozó:</strong>
              a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely az adatkezelő
              nevében személyes adatokat kezel. Adatvédelmi incidens: a biztonság olyan sérülése, amely a továbbított,
              tárolt vagy más módon kezelt személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését,
              megváltoztatását, jogosulatlan közlését vagy az azokhoz való jogosulatlan hozzáférést eredményezi.
            </p>
            <p>
              <strong>Honlap/Weboldal:</strong>
              az MGFÜ az által megbízott fejlesztő által üzemeltetett www.vali.hu vállalkozói portál.
            </p>
            <p>
              <strong>Felhasználó (adott esetben érintett):</strong>
              az a valamelyik gazdasági társasághoz kötődő (munkaviszony, vezető tisztségviselői szerep stb.)
              természetes személy, aki a weboldalra látogat, illetve a kapcsolattartásra szolgáló űrlapon megadja a
              személyes adatait.
            </p>
            <p>
              <strong>Címzett: </strong>
              az a természetes vagy jogi személy, illetve jogi személyiséggel nem rendelkező szervezet, aki vagy amely
              részére személyes adatot az adatkezelő, illetve az adatfeldolgozó hozzáférhetővé tesz.
            </p>
            <p>
              Adatkezelési Tájékoztató: az MGFÜ jelen Adatkezelési Tájékoztatója.
            </p>
            <p>
              Adatfeldolgozó:
            </p>
            <ul type="disc">
              <li>
                Google Inc. 1600 Amphitheatre Parkway, Mountain View, 3 California 94043, USA
              </li>
              <li>
                Facebook Inc. 1 Hacker Way, Menlo Park, California 94025, USA
              </li>
              <li>
                LinkedIn Inc. 1000 W Maude Ave, Sunnyvale, CA 94085, USA
              </li>
            </ul>
            <table border="0" cellpadding="0">
              <tbody>
                <tr>
                  <td>
                    <p>
                      <strong>
                        Nemzeti Infokummunikációs Szolgáltató Zrt.
                      </strong>
                      <br />
                      <br />
                      Cégjegyzékszám: 01-10-041633
                      <br />
                      Adószám: 10585560-2-44
                      <br />
                      Székhely: 1149 Budapest, Róna utca 52-80
                      <br />
                      web:
                      <a href="https://nisz.hu" target="_blank">
                        https://nisz.hu
                      </a>
                      /
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <ol start="1" type="1">
              <li>
                <strong>A kezelt adatok köre</strong>
                : Az érintett által megadott valamennyi személyes adat.
              </li>
              <li>
                <strong>Az érintettek köre</strong>
                : A weboldalt használó/az adatkezelő által kezelt valamennyi érintett.
              </li>
              <li>
                <strong>Az adatkezelés célja</strong>
                : A weboldal elérhetővé tétele, technikai háttér biztosítása.
              </li>
              <li>
                <strong>
                  Az adatkezelés időtartama, az adatok törlésének határideje:
                </strong>
                Az adatkezelő és a szolgáltató közötti megállapodás megszűnéséig, vagy az érintettnek a szolgáltató felé
                intézett törlési kérelméig tart az adatkezelés.
              </li>
              <li>
                <strong>Az adatfeldolgozás jogalapja:</strong>
                a felhasználó hozzájárulása, az Infotv. 5. § (1) bekezdése, 6. cikk (1) bekezdés a) pontja
              </li>
            </ol>
            <p>
              <strong>3. Egyes adatkezelések</strong>
            </p>
            <p>
              <strong>
                3.1 A rendszer által naplózott adatok (nem jár együtt személyes adatkezeléssel)
              </strong>
            </p>
            <p>
              Az MGFÜ honlapja (www.vali.hu) bizonyos területein cookie-kat (sütiket) használ a weboldalt felhasználók
              tevékenységének követéséhez.
            </p>
            <p>
              A cookie-k egy olyan egyedi azonosításra, illetve profilinformációk tárolására alkalmas jelsorozatok,
              információs fájlok, amelyeket a szolgáltatók a felhasználó számítógépére helyeznek el, és amelyek így
              lehetővé teszik, hogy egy weboldal a felhasználó böngészési szokásairól adatokat rögzítsen (például
              tárolják a felhasználók preferenciáit és beállításait; segítenek a bejelentkezésben és elemzik a webhely
              működését).
            </p>
            <p>
              A cookie-ban tárolt jelsorozat azonban önmagában csak a felhasználó számítógépének felismerésére alkalmas,
              nem képes egyedileg is azonosítani a felhasználót.
            </p>
            <ol start="1" type="a">
              <li>
                Az érintettek köre: A <a href="http://www.vali.hu">www.vali.hu</a>
                honlapot látogató valamennyi felhasználó.
              </li>
              <li>
                Az adatkezelés jogalapja:
              </li>
              <ol start="1" type="1">
                <li>
                  A weblap használatához elengedhetetlen cookie-k esetében adatkezelő jogos érdeke. [GDPR 6. cikk (1)
                  f)]
                </li>
                <li>
                  A további cookie-k esetében a felhasználó hozzájárulása. [GDPR 6. cikk (1) a)]
                </li>
              </ol>
              <li>
                Az adatok megismerésére jogosult személyek: A cookie-k használatával nem kezel személyes adatokat sem az
                MGFÜ, sem az adatfeldolgozók.
              </li>
              <li>
                Az érintettek (felhasználók) jogai: Az érintettnek lehetőségük van a cookie-alkalmazás beállításait a
                weboldalon biztosított beállítási funkciókkal szabályozni.
              </li>
              <li>
                Az adatkezelés célja, az adatkezelés időtartama, az adatok törlésének határideje: Az oldalon alkalmazott
                cookie-król, azok beállításairól tételes áttekintés olvasható külön ezzel a céllal készült „Cookie
                tájékoztató” menüpontban, amely a cookie beállítások elfogadása előtt a böngészőablak alján látható
                sávból, illetve ezt követően a weboldal láblécéből érhető el.
              </li>
            </ol>
            <p>
              <strong>3.2 A felhasználói fiók létrehozásakor megadott adatok</strong>
            </p>
            <p>
              A www.vali.hu weboldalon a regisztráció ugyan céghez kötött, de a regisztrációhoz a „<strong>Név</strong>”
              „<strong>Telefonszám</strong>” és „<strong>E-mail cím</strong>” mezők kitöltése is kötelező, melyek ugyan
              nem szükségszerűen személyes adatok, de akár személyes jellegű adatok is lehetnek.
            </p>
            <p>
              A felhasználó a regisztrációkor dönthet úgy, hogy már meglévő közösségi oldal-fiókját (Facebook, Google,
              LinkedIn) használja a regisztrációhoz, ebben az esetben a felhasználó közösségi oldalon regisztrált neve,
              és a közösségi oldalon regisztrált e-mail címe kerül tárolásra.
            </p>
            <p>
              <strong>3.3 A kapcsolatfelvétel kezdeményezésekor megadott adatok</strong>
            </p>
            <p>
              A <a href="https://vali.hu/contact">https://vali.hu/contact</a> oldalon a felhasználó kapcsolatfelvételt
              kezdeményezhet, melynek elindításához a „Teljes név” és az „E-mail cím” mezők kitöltése kötelező.
            </p>
            <p>
              Ezen adatokhoz az MGFÜ Kommunikációs osztályának munkatársai férhetnek hozzá a feladataik ellátása
              érdekében.
            </p>
            <p>
              <strong>4. Az adatokhoz való hozzáférés és az adattovábbítás</strong>
            </p>
            <p>
              <strong>4.1. A regisztráció során megadott adatok</strong>
            </p>
            <p>
              A regisztráció során megadott adatokat (Név, Telefonszám és E-mail cím) az adatkezelő és az adatfeldolgozó
              kizárólag a regisztrált személlyel való kapcsolattartási, és azonosítási célból tárolja.
            </p>
            <p>
              <strong>4.2. A kapcsolatfelvétel során megadott adatok</strong>
            </p>
            <p>
              A kapcsolatfelvétel során a válaszadáshoz esetlegesen szükséges harmadik fél részére történő
              adattovábbítás az érintett külön, eseti hozzájárulása nélkül végezhető, mivel ezen adattovábbítás
              tekintetében az érintett megadja kifejtett és egyértelmű hozzájárulását jelen Adatvédelmi Tájékoztató
              megismerése és elfogadását követően az űrlapon keresztül történő önkéntes kapcsolatfelvétel során.
              <br />
              <br />
              Az űrlap kitöltése és elküldése során egy bejegyzés keletkezik automatizált formában a weboldalt
              kiszolgáló szerver rendszernaplózását rögzítő úgynevezett „log fájlban”. Ez a fájl tartalmazza a
              felhasználó által a weboldalon megadott név és e-mail cím adatokat, illetve az adatrögzítés időpontját,
              azonban az adatfeldolgozók ezeket az adatokat tartalmazó fájlokat nem monitorozzák, azok csupán a
              szerverüzemeltetés során biztonsági okokból keletkeznek és a bennük található adatok 7 naptári nap
              elteltével automatikusan és visszaállíthatatlan formában törlődnek a szerverről.
            </p>
            <p>
              <strong>5. Az adatkezeléssel kapcsolatos jogok</strong>
            </p>
            <p>
              <strong>5.1. A tájékoztatáskéréshez való jog</strong>
            </p>
            <p>
              Az érintett személy az 1. pontban megadott elérhetőségeken keresztül, írásban tájékoztatást kérhet az
              MGFÜ-tól arról, hogy
            </p>
            <ul type="disc">
              <li>
                milyen személyes adatait,
              </li>
              <li>
                milyen jogalapon,
              </li>
              <li>
                milyen adatkezelési cél miatt,
              </li>
              <li>
                milyen forrásból,
              </li>
              <li>
                mennyi ideig kezeli,
              </li>
              <li>
                az MGFÜ kinek, mikor, milyen jogszabály alapján, mely személyes adataihoz biztosított hozzáférést vagy
                kinek továbbította a személyes adatait.
              </li>
            </ul>
            <p>
              Az MGFÜ az érintett kérelmét legfeljebb egy hónapon belül, az általa megadott elérhetőségre küldött
              levélben teljesíti.
            </p>
            <p>
              <strong>5.2. A helyesbítéshez való jog</strong>
            </p>
            <p>
              Az érintett személy az 1. pontban megadott elérhetőségeken keresztül, írásban kérheti, hogy az MGFÜ-t
              módosítsa valamely személyes adatát (például bármikor megváltoztathatja az email címét). Az MGFÜ a
              kérelmet legfeljebb egy hónapon belül teljesíti, és erről az általa megadott elérhetőségre küldött
              levélben vagy e-mail útján értesíti.
            </p>
            <p>
              <strong>5.3. Az adatkezelés korlátozásához való jog</strong>
            </p>
            <p>
              Az érintett személy az 1. pontban megadott elérhetőségeken keresztül, írásban kérheti, hogy a személyes
              adatai kezelését az MGFÜ korlátozza, ha az érintett vitatja a kezelt személyes adatok pontosságát. Ebben
              az esetben a korlátozás arra az időtartamra vonatkozik, amely lehetővé teszi, hogy az MGFÜ ellenőrizze a
              személyes adatok pontosságát. Az MGFÜ megjelöli az általa kezelt személyes adatot, ha az érintett vitatja
              annak helyességét vagy pontosságát, de a vitatott személyes adat helytelensége vagy pontatlansága nem
              állapítható meg egyértelműen.
              <br />
              Az érintett kérheti, hogy személyes adatainak kezelését az MGFÜ korlátozza akkor is, ha az adatkezelés
              jogellenes, de az érintett ellenzi a kezelt személyes adatok törlését, és ehelyett kéri azok
              felhasználásának korlátozását.
              <br />
              Az érintett továbbá akkor is kérheti, hogy személyes adatainak kezelését az MGFÜ korlátozza, ha az
              adatkezelés célja megvalósult, de az érintett igényli azok adatkezelő általi kezelését jogi igények
              előterjesztéséhez, érvényesítéséhez vagy védelméhez.
            </p>
            <p>
              <strong>5.4. A tiltakozáshoz való jog</strong>
            </p>
            <p>
              Az érintett személy az 1. pontban megadott elérhetőségeken keresztül, írásban tiltakozhat az adatkezelés
              ellen. Az MGFÜ a kérelmet legfeljebb egy hónapon belül teljesíti, és erről az érintett személy által
              megadott elérhetőségre küldött levélben vagy e-mail útján értesíti.
            </p>
            <p>
              <strong>5.5. A törléshez való jog</strong>
            </p>
            <p>
              Az érintett személy jogosult arra, hogy kérésére az MGFÜ indokolatlan késedelem nélkül törölje a rá
              vonatkozó személyes adatokat, az MGFÜ pedig köteles arra, hogy az érintettre vonatkozó személyes adatokat
              indokolatlan késedelem nélkül törölje, ha a jogszabályban fennálló indokok valamelyike fennáll.
              <br />
              Felhívjuk figyelmét, hogy ez az érintetti jog nem alkalmazandó, amennyiben az adatkezelés szükséges jogi
              igények előterjesztéséhez, érvényesítéséhez, illetve védelméhez. Ha nem lehetséges egy adat törlése, azt
              az adatot az adatkezelő zárolja.
            </p>
            <p>
              <strong>6. Adatfeldolgozás</strong>
            </p>
            <p>
              <strong>6.1. Üzemeltetéshez igénybevett adatfeldolgozó</strong>
            </p>
            <p>
              Az MGFÜ a www.vali.hu honlap üzemeltetéséhez a jelen Adatkezelési Tájékoztatóban fentebb nevesített
              adatfeldolgozót veszi igénybe.
            </p>
            <p>
              <strong>6.2.</strong>
              <strong>Az adatfeldolgozó hatásköre</strong>
            </p>
            <p>
              Az adatfeldolgozó (weboldal fejlesztője) önálló döntést nem hoz, kizárólag az MGFÜ-val kötött szerződés
              alapján, és a kapott utasítások szerint jogosult eljárni.
            </p>
            <p>
              Az adatfeldolgozó további adatfeldolgozó igénybevételére csak az MGFÜ hozzájárulásával jogosult.
            </p>
            <p>
              <strong>7. Az adatkezelés alapjául szolgáló jogszabályok</strong>
            </p>
            <p>
              Az MGFÜ a www.vali.hu elnevezésű honlapjára történő látogatással kapcsolatos adatkezelésekre, illetve az
              Adatkezelési Tájékoztatóban használt fogalmakra vonatkozó jogszabályok:
            </p>
            <ul type="disc">
              <li>
                Az Európai Parlament és a Tanács (EU) 2016/679 Rendelete (2016. április 27.) a természetes személyeknek
                a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról,
                valamint a 95/46/EK irányelv hatályon kívül helyezéséről (általános adatvédelmi rendelet) (a
                továbbiakban: GDPR)
              </li>
              <li>
                az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény (a
                továbbiakban: Info tv.),
              </li>
              <li>
                az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalommal összefüggő
                szolgáltatások egyes kérdéseiről szóló 2001. évi CVIII. törvény
              </li>
              <li>
                <strong>Az adatkezelés biztonsága</strong>
              </li>
            </ul>
            <p>
              <strong>
                8. Az adatkezeléssel kapcsolatos jogérvényesítési lehetősége
              </strong>
            </p>
            <p>
              Tájékoztatjuk, hogy az Ön személyes adatai megfelelő védelméhez szükséges technikai és szervezési
              intézkedéseket megtettük. A jogosulatlan hozzáférés megakadályozására a regisztráció megerősítést igényel.
              A rendszerünket – a külső hozzáférés megakadályozása céljából – tűzfalak védik. Adminisztrációs
              felületeink kizárólag belső hálózatból érhetők el. Személyes adatait jelszóval védett formában tároljuk.
              Az adatok véletlen megsemmisülését biztonsági mentésekkel akadályozzuk meg. Adatkezelőként társaságunknál
              az adatvédelmi tisztviselő kijelölésére megtörtént.
            </p>
            <p>
              Az adatvédelmi tisztviselő neve és elérhetősége: dr. Nagy Katalin,
              <a href="mailto:adatvedelem@mgfu.hu">adatvedelem@mgfu.hu</a>, +36 1 312 2213.
            </p>

            <p>
              <strong>9. Az érintett tájékoztatása az adatvédelmi incidensről</strong>
            </p>
            <p>
              Ha az adatvédelmi incidens valószínűsíthetően magas kockázattal jár a természetes személyek jogaira és
              szabadságaira nézve, az adatkezelő indokolatlan késedelem nélkül tájékoztatja az érintettet az adatvédelmi
              incidensről.
            </p>
            <p>
              Az érintett részére adott tájékoztatásban <strong>világosan és közérthetően</strong> ismertetni kell az
              adatvédelmi incidens jellegét, és közölni kell az adatvédelmi tisztviselő vagy a további tájékoztatást
              nyújtó egyéb kapcsolattartó nevét és elérhetőségeit; ismertetni kell az adatvédelmi incidensből eredő,
              valószínűsíthető következményeket; ismertetni kell az adatkezelő által az adatvédelmi incidens orvoslására
              tett vagy tervezett intézkedéseket, beleértve adott esetben az adatvédelmi incidensből eredő esetleges
              hátrányos következmények enyhítését célzó intézkedéseket.
            </p>
            <p>
              Az érintettet nem kell tájékoztatni, ha a következő feltételek bármelyike teljesül:
            </p>
            <ul type="disc">
              <li>
                az adatkezelő
                <strong>
                  megfelelő technikai és szervezési védelmi intézkedéseket hajtott végre
                </strong>
                , és ezeket az intézkedéseket az adatvédelmi incidens által érintett adatok tekintetében alkalmazták,
                különösen azokat az intézkedéseket – mint például a titkosítás alkalmazása –, amelyek a személyes
                adatokhoz való hozzáférésre fel nem jogosított személyek számára
                <strong>értelmezhetetlenné teszik az adatokat;</strong>
              </li>
              <li>
                az adatkezelő az adatvédelmi incidenst követően olyan további intézkedéseket tett, amelyek
                <strong>
                  biztosítják, hogy az érintett jogaira és szabadságaira jelentett, magas kockázat a továbbiakban
                  valószínűsíthetően nem valósul meg
                </strong>
                ;
              </li>
              <li>
                a tájékoztatás <strong>aránytalan erőfeszítést tenne szükségessé</strong>. Ilyen esetekben az
                érintetteket nyilvánosan közzétett információk útján kell tájékoztatni, vagy olyan hasonló intézkedést
                kell hozni, amely biztosítja az érintettek hasonlóan hatékony tájékoztatását.
              </li>
            </ul>
            <p>
              Ha az adatkezelő még nem értesítette az érintettet az adatvédelmi incidensről, a felügyeleti hatóság,
              miután mérlegelte, hogy az adatvédelmi incidens valószínűsíthetően magas kockázattal jár-e, elrendelheti
              az érintett tájékoztatását.
            </p>
            <p>
              <strong>
                10. Az adatkezeléssel kapcsolatos jogérvényesítési lehetősége
              </strong>
            </p>
            <p>
              <strong>10.1. Adatkezeléssel kapcsolatos kérdések</strong>
            </p>
            <p>
              Bármilyen, az adatkezeléshez kapcsolódó kérdéssel, észrevétellel az adatkezelő adatvédelmi tisztviselője
              kereshető meg az adatvedelem@mgfu.hu e-mail címen. <strong></strong>
            </p>
            <p>
              <strong>10.2.</strong>
              <strong>Adatkezeléssel kapcsolatos panasz benyújtása</strong>
            </p>
            <p>
              A Felhasználó az adatkezeléssel kapcsolatos panaszával közvetlenül a Nemzeti Adatvédelmi és
              Információszabadság Hatósághoz (cím: 1055 Budapest, Falk Miksa utca 9-11., Levelezési cím: 1363 Budapest,
              Postafiók: 9.; telefon: +36-1-391-1400; e-mail: ugyfelszolgalat@naih.hu; honlap: www.naih.hu) fordulhat.
            </p>
            <p>
              <strong>10.3. Jogellenes adatkezelés esetén</strong>
            </p>
            <p>
              A Felhasználó, ha a személyes adatai kezelésének jogellenességét tapasztalja, polgári pert kezdeményezhet
              az MGFÜ ellen. A per elbírálása a törvényszék hatáskörébe tartozik. A per – az érintett választása szerint
              – az érintett lakóhelye vagy tartózkodási helye szerinti törvényszék előtt is megindítható (a
              törvényszékek felsorolását és elérhetőségét az alábbi linken keresztül tekintheti meg:
              http://birosag.hu/torvenyszekek).
            </p>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>
